export default {
  name: 'index-page',

  created() {}

};